import { search } from './search'
import { getDetail } from './detail'

export const spottedApi = {
  search,
  getDetail,
}
